import { createModuleInit } from '@rcm/redux-global';

const initCart = createModuleInit({

});

export default initCart;
